import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as Yup from 'yup';
import { useState, useEffect, useCallback } from 'react';
import { isEqual } from 'lodash-es';
import { I_DO_NOT_KNOW_ID } from '@poplar/constants/intake';
import { SingleChoiceElement, getSingleChoiceInitialValues, getSingleChoiceValidationSchema } from './intake-form/SingleChoice';
import { MultipleChoiceElement, getMultipleChoiceInitialValues, getMultipleChoiceValidationSchema } from './intake-form/MultipleChoice';
import { FileUploadElement, getFileUploadInitialValues, getFileUploadValidationSchema } from './intake-form/FileUpload';
import { TextElement, getTextInitialValues, getTextValidationSchema } from './intake-form/TextAnswer';
import { BooleanElement, getBooleanInitialValues, getBooleanValidationSchema } from './intake-form/BooleanAnswer';
import { IntegerElement, getIntegerInitialValues, getIntegerValidationSchema } from './intake-form/IntegerAnswer';
import { DateElement, getDateInitialValues, getDateValidationSchema } from './intake-form/DateAnswer';
import { MoneyElement, getMoneyInitialValues, getMoneyValidationSchema } from './intake-form/MoneyAnswer';
import { AddressElement, getAddressInitialValues, getAddressValidationSchema } from './intake-form/AddressAnswer';
import { DateTimeElement, getDateTimeInitialValues, getDateTimeValidationSchema } from './intake-form/DateTimeAnswer';
import { MonthAndDayElement, getMonthAndDayInitialValues, getMonthAndDayValidationSchema } from './intake-form/MonthAndDayAnswer';
import { IDoNotKnowElement, getIDoNotKnowInitialValues, getIDoNotKnowValidationSchema } from './intake-form/IDoNotKnowAnswer';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { usePreferredCurrency } from '@poplar/hooks/usePreferredCurrency';
import { jsx as _jsx } from "react/jsx-runtime";
export var answerOptionSortFn = function answerOptionSortFn(a, b) {
  return a.order - b.order;
};
export var getInitialValues = function getInitialValues(question, _ref) {
  var locale = _ref.locale,
      currency = _ref.currency,
      country = _ref.country,
      initToUndefined = _ref.initToUndefined;
  if (!question) return;
  var initialValues = {};

  _toConsumableArray(question.answerOptionsList).sort(answerOptionSortFn).forEach(function (answer, i) {
    if (answer.textAnswer) {
      initialValues[i] = getTextInitialValues(initToUndefined ? undefined : answer.textAnswer);
    } else if (answer.booleanAnswer) {
      initialValues[i] = getBooleanInitialValues(initToUndefined ? undefined : answer.booleanAnswer);
    } else if (answer.integerAnswer) {
      initialValues[i] = getIntegerInitialValues(initToUndefined ? undefined : answer.integerAnswer);
    } else if (answer.dateAnswer) {
      initialValues[i] = getDateInitialValues(initToUndefined ? undefined : answer.dateAnswer);
    } else if (answer.moneyAnswer) {
      initialValues[i] = getMoneyInitialValues(initToUndefined ? undefined : answer.moneyAnswer, locale, currency);
    } else if (answer.singleChoiceAnswer) {
      // Determine if initialization to undefined should be avoided due to the presence of a choice explicitly marked as 'true' for preselected
      var hasPreselectedChoice = answer.singleChoiceAnswer.choicesList.some(function (choice) {
        return choice.preselected === true;
      });
      initialValues[i] = getSingleChoiceInitialValues(answer.singleChoiceAnswer, country, hasPreselectedChoice ? true : !initToUndefined);
    } else if (answer.addressAnswer) {
      initialValues[i] = getAddressInitialValues(initToUndefined ? undefined : answer.addressAnswer, country);
    } else if (answer.multipleChoicesAnswer) {
      initialValues[i] = getMultipleChoiceInitialValues(initToUndefined ? undefined : answer.multipleChoicesAnswer, country);
    } else if (answer.dateTimeAnswer) {
      initialValues[i] = getDateTimeInitialValues(initToUndefined ? undefined : answer.dateTimeAnswer);
    } else if (answer.monthAndDayAnswer) {
      initialValues[i] = getMonthAndDayInitialValues(initToUndefined ? undefined : answer.monthAndDayAnswer);
    } else if (answer.fileAnswer) {
      initialValues[i] = getFileUploadInitialValues(initToUndefined ? undefined : answer.fileAnswer);
    } else if (answer.idonotknowAnswer) {
      initialValues[I_DO_NOT_KNOW_ID] = getIDoNotKnowInitialValues(initToUndefined ? undefined : answer.idonotknowAnswer);
    }
  });

  return _defineProperty({}, question.id, initialValues);
};
export var getValidationSchema = function getValidationSchema(question, selectedAnswerOptionDependencies, t, country) {
  if (!question) return;
  var validationSchemas = [];

  _toConsumableArray(question.answerOptionsList).sort(answerOptionSortFn).forEach(function (answer, index) {
    var _question$isOptional;

    // Only show dependent answerOptions if the single choice is selected
    if ( // dependenciesList is 1-indexed
    question.answerOptionsWithDependenciesList.includes(index + 1) && !selectedAnswerOptionDependencies.includes(index + 1)) {
      return;
    } // 'AnswerOption.isOptional' is not currently supported. I'm leaving the skeleton in place for when it is.


    var answerOptional = ((_question$isOptional = question.isOptional) === null || _question$isOptional === void 0 ? void 0 : _question$isOptional.value) || answer.isOptional;

    if (answer.textAnswer) {
      validationSchemas.push(_defineProperty({}, index, getTextValidationSchema(answerOptional, t)));
    } else if (answer.booleanAnswer) {
      validationSchemas.push(_defineProperty({}, index, getBooleanValidationSchema(answerOptional)));
    } else if (answer.integerAnswer) {
      validationSchemas.push(_defineProperty({}, index, getIntegerValidationSchema(answer.integerAnswer, answerOptional, t)));
    } else if (answer.dateAnswer) {
      validationSchemas.push(_defineProperty({}, index, getDateValidationSchema(answerOptional, t)));
    } else if (answer.moneyAnswer) {
      validationSchemas.push(_defineProperty({}, index, getMoneyValidationSchema(answerOptional, t)));
    } else if (answer.singleChoiceAnswer) {
      validationSchemas.push(_defineProperty({}, index, getSingleChoiceValidationSchema(answer.singleChoiceAnswer, answerOptional, country, t)));
    } else if (answer.addressAnswer) {
      validationSchemas.push(_defineProperty({}, index, getAddressValidationSchema(answerOptional, country, t)));
    } else if (answer.multipleChoicesAnswer) {
      validationSchemas.push(_defineProperty({}, index, getMultipleChoiceValidationSchema(answer.multipleChoicesAnswer, answerOptional, country, t)));
    } else if (answer.dateTimeAnswer) {
      validationSchemas.push(_defineProperty({}, index, getDateTimeValidationSchema(answerOptional, t)));
    } else if (answer.monthAndDayAnswer) {
      validationSchemas.push(_defineProperty({}, index, getMonthAndDayValidationSchema(answerOptional, t)));
    } else if (answer.fileAnswer) {
      validationSchemas.push(_defineProperty({}, index, getFileUploadValidationSchema("".concat(question.id, ".").concat(index), answerOptional)));
    } else if (answer.idonotknowAnswer) {
      validationSchemas.push(_defineProperty({}, I_DO_NOT_KNOW_ID, getIDoNotKnowValidationSchema()));
    }
  }); // TODO, when 'isOptional' Property is supported, use it instead, remove hack below
  //return Yup.object().shape({ [question.id]: Yup.object().shape(validationSchemas) });


  return Yup.object().shape(_defineProperty({}, question.id, Yup.mixed().test(function (values, ctx) {
    var nonRequireErrors = [];
    var requireErrors = [];
    validationSchemas.forEach(function (schema) {
      try {
        Yup.object().shape(schema).validateSync(values);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          var _error$path, _error$path2;

          if ( // 'oneOf' needed for Boolean types, oneOf([true]) is the equivalent of 'required'
          error.type === 'oneOf' || // For multipleChoiceAnswer, min(1) is the equivalent of 'required'
          error.type === 'min' && (_error$path = error.path) !== null && _error$path !== void 0 && _error$path.includes('.selected') || // For singleChoiceAnswer, 'other' option must always be answered when shown
          error.type === 'required' && !((_error$path2 = error.path) !== null && _error$path2 !== void 0 && _error$path2.includes('.other'))) {
            requireErrors.push(ctx.createError({
              path: "".concat(question.id, ".").concat(error.path),
              message: error.message
            }));
          } else {
            nonRequireErrors.push(ctx.createError({
              path: "".concat(question.id, ".").concat(error.path),
              message: error.message
            }));
          }
        } else {
          throw error;
        }
      }
    }); // To match Azalea functionality, only return an error for any other type than 'required'

    if (nonRequireErrors.length > 0) {
      return new Yup.ValidationError(nonRequireErrors);
    } // TODO: implement requireAllAnswerOptions as outlined in the proto comments to
    // respect values in answerOptionsWithDependencies; however, the current questions
    // (notably the repeating ones) work well without it


    if (requireErrors.length > (question.requireAllAnswerOptions ? 0 : validationSchemas.length - 1)) {
      return new Yup.ValidationError(requireErrors);
    }

    return true;
  })));
};
export var QuestionElements = function QuestionElements(_ref3) {
  var question = _ref3.question,
      isDisabled = _ref3.isDisabled,
      selectedAnswerOptionDependencies = _ref3.selectedAnswerOptionDependencies,
      setSelectedAnswerOptionDependencies = _ref3.setSelectedAnswerOptionDependencies,
      formikProps = _ref3.formikProps;
  var setFieldValue = formikProps.setFieldValue;

  var _useIntlMeta = useIntlMeta(),
      country = _useIntlMeta.country,
      locale = _useIntlMeta.locale;

  var currency = usePreferredCurrency(); // using a map to track the relationships between individual answers and the dependencies that they trigger

  var _useState = useState({}),
      selectedAnswerOptionDependenciesMap = _useState[0],
      setSelectedAnswerOptionDependenciesMap = _useState[1];

  var onSetSelectedAnswerOptionDependencies = useCallback(function (deps, id) {
    var newMap = _objectSpread(_objectSpread({}, selectedAnswerOptionDependenciesMap), {}, _defineProperty({}, id, deps)); // cleaning up dependencies that are no longer referenced
    // and making sure their values get cleared


    if (selectedAnswerOptionDependenciesMap[id]) {
      selectedAnswerOptionDependenciesMap[id].forEach(function (dep) {
        var depId = "".concat(question.id, ".").concat(dep - 1); // don't clear the inputted form value in case the newly selected answer
        // dependencies contains one that already exists in the UI

        if (!deps.includes(dep)) {
          var _getInitialValues;

          var initialValue = (_getInitialValues = getInitialValues(question, {
            locale: locale,
            currency: currency,
            country: country,
            initToUndefined: true
          })) === null || _getInitialValues === void 0 ? void 0 : _getInitialValues[question.id][dep - 1];
          setFieldValue(depId, initialValue);
          delete newMap[depId];
        }
      });
    } // because selectedAnswerOptionDependenciesMap is a dep of this callback,
    // we need a deep equality function to avoid infinite loops in case something
    // is listening on changes to this callback instance


    if (!isEqual(selectedAnswerOptionDependenciesMap, newMap)) {
      setSelectedAnswerOptionDependenciesMap(newMap);
    }
  }, [selectedAnswerOptionDependenciesMap, setFieldValue, country, currency, locale, question]);
  useEffect(function () {
    setSelectedAnswerOptionDependencies(_toConsumableArray(new Set(Object.values(selectedAnswerOptionDependenciesMap).flat())));
  }, [selectedAnswerOptionDependenciesMap, setSelectedAnswerOptionDependencies]);
  return _toConsumableArray(question.answerOptionsList).sort(answerOptionSortFn).map(function (answer, i) {
    var id = "".concat(question.id, ".").concat(i); // Only show dependent answerOptions if the single choice is selected

    if ( // dependenciesList is 1-indexed
    question.answerOptionsWithDependenciesList.includes(i + 1) && !selectedAnswerOptionDependencies.includes(i + 1)) {
      return;
    }

    var commonProps = {
      id: id,
      isDisabled: isDisabled,
      formikProps: formikProps
    };

    if (answer.textAnswer) {
      return /*#__PURE__*/_jsx(TextElement, _objectSpread(_objectSpread({}, commonProps), answer), id);
    }

    if (answer.booleanAnswer) {
      return /*#__PURE__*/_jsx(BooleanElement, _objectSpread(_objectSpread({}, commonProps), answer), id);
    }

    if (answer.integerAnswer) {
      return /*#__PURE__*/_jsx(IntegerElement, _objectSpread(_objectSpread({}, commonProps), answer), id);
    }

    if (answer.dateAnswer) {
      return /*#__PURE__*/_jsx(DateElement, _objectSpread(_objectSpread({}, commonProps), answer), id);
    }

    if (answer.moneyAnswer) {
      return /*#__PURE__*/_jsx(MoneyElement, _objectSpread(_objectSpread({}, commonProps), answer), id);
    }

    if (answer.singleChoiceAnswer) {
      return /*#__PURE__*/_jsx(SingleChoiceElement, _objectSpread(_objectSpread({}, commonProps), {}, {
        setSelectedAnswerOptionDependencies: function setSelectedAnswerOptionDependencies(deps) {
          return onSetSelectedAnswerOptionDependencies(deps, id);
        }
      }, answer), id);
    }

    if (answer.addressAnswer) {
      return /*#__PURE__*/_jsx(AddressElement, _objectSpread(_objectSpread({}, commonProps), answer), id);
    }

    if (answer.multipleChoicesAnswer) {
      return /*#__PURE__*/_jsx(MultipleChoiceElement, _objectSpread(_objectSpread({}, commonProps), answer), id);
    }

    if (answer.dateTimeAnswer) {
      return /*#__PURE__*/_jsx(DateTimeElement, _objectSpread(_objectSpread({}, commonProps), answer), id);
    }

    if (answer.monthAndDayAnswer) {
      return /*#__PURE__*/_jsx(MonthAndDayElement, _objectSpread(_objectSpread({}, commonProps), answer), id);
    }

    if (answer.fileAnswer) {
      return /*#__PURE__*/_jsx(FileUploadElement, _objectSpread(_objectSpread({}, commonProps), answer), id);
    }

    if (answer.idonotknowAnswer) {
      var idkId = "".concat(question.id, ".").concat(I_DO_NOT_KNOW_ID);
      return /*#__PURE__*/_jsx(IDoNotKnowElement, _objectSpread(_objectSpread(_objectSpread({}, commonProps), answer), {}, {
        id: idkId
      }), idkId);
    }
  });
};